import { render, staticRenderFns } from "./Carousel_new.vue?vue&type=template&id=3ff4f803&"
import script from "./Carousel_new.vue?vue&type=script&lang=js&"
export * from "./Carousel_new.vue?vue&type=script&lang=js&"
import style0 from "./Carousel_new.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports